import React from 'react'
import { connect } from 'react-redux'
import FormInput from './FormInput'
import FormDropdown from './FormDropdown'
import Bar from './Bar'
import {
    ajaxFeedbackFilterV2,
    convertTimeframeTitle,
    deleteRatingsFilter,
    getLocation,
    setCurrentPage,
    setCustomTimeframe,
    setFilterTimeframe,
    setLocation,
    setQuery,
    setRatingsFilter,
    setSorting,
    updateModalContent,
    validateFeedbackSorting
} from '../redux/FeedbackRedux'

class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        if (props.state.timeframe === null) {
            let timeframe = window.localStorage.getItem("timeframe");
            timeframe = timeframe === null ? "last30" : timeframe;
            if (props.state.custom_qr_code !== null)
                timeframe = "lifetime"
            props.dispatch(setFilterTimeframe(timeframe));
        }

        let sorting = window.localStorage.getItem("sorting");
        props.dispatch(setSorting(validateFeedbackSorting(sorting)));

        let location = getLocation();

        if (window.filterRating !== null && window.filterRating !== undefined) {
            setRatingsFilter(window.filterRating);
        } else if (props.state.status === window.feedbackStatus.RatingsOnly.value && location && location.current !== 'FeedbackDetailBar') {
            props.state.business.five_star_minimum ? setRatingsFilter([4, 3, 2, 1]) : setRatingsFilter([3, 2, 1]);
        }else if (location && location.current !== 'FeedbackDetailBar') {
            deleteRatingsFilter();
        }

        props.dispatch(ajaxFeedbackFilterV2(true, true))

        this.state = {
            displayClear: props.state.query !== "",
            status: props.state.status === "null" || props.state.status === null ? "All" : props.state.status,
        }

        setLocation('SearchBar');
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            this.props.state.filterFeedbacksCount !== prevProps.state.filterFeedbacksCount
        ) {
            const open = document.querySelectorAll('.sidebar-feedback-history-status-open');
            if (open.length > 0 && this.props.state.filterFeedbacksCount.feedbackCountDetails.countOpen !== undefined) {
                open.forEach(item => item.innerHTML = this.props.state.filterFeedbacksCount.feedbackCountDetails.countOpen);
                open.forEach(item => item.classList.remove('hidden'));
                if (this.props.state.filterFeedbacksCount.hasPriorities &&
                    this.props.state.filterFeedbacksCount.hasPriorities.Open &&
                    this.props.state.filterFeedbacksCount.hasPriorities.Open[30]) {
                    open.forEach(item => item.classList.add('anim-pulse-side-bar')); // intentional pulse only for priority 30 (red/high)
                } else {
                    open.forEach(item => item.classList.remove('anim-pulse-side-bar'));
                }
            }

            const pending = document.querySelectorAll('.sidebar-feedback-history-status-pending');
            if (pending.length > 0 && this.props.state.filterFeedbacksCount.feedbackCountDetails.countPending !== undefined) {
                pending.forEach(item => item.innerHTML = this.props.state.filterFeedbacksCount.feedbackCountDetails.countPending);
                pending.forEach(item => item.classList.remove('hidden'));
                if (this.props.state.filterFeedbacksCount.feedbackCountDetails.countPending > 0 ) {
                    pending.forEach(item => item.classList.add('anim-pulse-side-bar')); // intentional pulse for any priority
                } else {
                    pending.forEach(item => item.classList.remove('anim-pulse-side-bar'));
                }
            }

            const resolved = document.querySelectorAll('.sidebar-feedback-history-status-resolved');
            if (resolved.length > 0 && this.props.state.filterFeedbacksCount.feedbackCountDetails.countResolved !== undefined) {
                resolved.forEach(item => item.innerHTML = this.props.state.filterFeedbacksCount.feedbackCountDetails.countResolved);
                resolved.forEach(item => item.classList.remove('hidden'));
            }

            const all = document.querySelectorAll('.sidebar-feedback-history-status-all');
            if (all.length > 0 && this.props.state.filterFeedbacksCount.feedbackCountDetails.countAll !== undefined) {
                all.forEach(item => item.innerHTML = this.props.state.filterFeedbacksCount.feedbackCountDetails.countAll);
                all.forEach(item => item.classList.remove('hidden'));
            }
            const RatingsOnly = document.querySelectorAll('.sidebar-feedback-history-status-neg-rating-no-fb');
            if (RatingsOnly.length > 0 && this.props.state.filterFeedbacksCount.feedbackCountDetails.countRatingsOnly !== undefined) {
                RatingsOnly.forEach(item => item.innerHTML = this.props.state.filterFeedbacksCount.feedbackCountDetails.countRatingsOnly);
                RatingsOnly.forEach(item => item.classList.remove('hidden'));
            }
        }
    }

    dispatchSearch() {
        let query = $("input.feedback-search").val();
        window.localStorage.setItem("feedback_search", query);
        this.props.dispatch(setQuery(query));
        this.props.dispatch(ajaxFeedbackFilterV2(true, true))
    }

    dispatchTimeframe() {
        const $el = $(event.target);
        let timeframe = $el.attr("id");
        const timeframeLabel = $el.text();

        window.localStorage.setItem("timeframe", timeframe);
        window.localStorage.setItem("timeframeLabel", timeframeLabel);

        if (timeframe !== "custom") {
            window.localStorage.removeItem("prev_date");
            window.localStorage.removeItem("next_date");
        }

        this.props.dispatch(setFilterTimeframe(timeframe));
        this.props.dispatch(ajaxFeedbackFilterV2(true, true));

        const input = document.querySelector('.timelineFeedbackHiddenInput');
        input.value = timeframeLabel
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    dispatchDiplayStatus() {
        let status = $(event.target).attr("id");
        if (this.state.status == status) return;
        if (this.state.status == "All") {
            window.location.href = window.location.href + `?status=${status}`;
        } else {
            window.location.href = window.location.href.replace(`?status=${this.state.status}`, status == "All" ? "" : `?status=${status}`);
        }
        this.setState({ ...this.state, status });
    }

    handleExportClick(event) {
        const modal_id = "download_XLS";
        const modal_title = __('Download XLS Export');
        const modal_body = "exportXls";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Cancel");
        const button_2_class = "primary";
        const button_2_id = "export_xls_send_btn";
        const button_2_text = __("Send Report");
        this.props.dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text }));
        jQuery('.modal:not(.error)').modal();
    }

    doChangeTimeFrame() {
        var prev = jQuery("#start_date").val();
        var next = jQuery("#end_date").val();

        if (prev > next) {
            document.getElementById("start_date").blur();
            document.getElementById("end_date").blur();
            this.props.dispatch(updateModalContent({ modal_id: "date_late_error", modal_title: __('End Date must be later than the Start Date.'), modal_body: '', button_1_class: 'primary', button_1_id: 'cancel', button_1_text: __('Ok') }));
            jQuery('.modal:not(.error)').modal();
            return;
        }

        window.localStorage.setItem("prev_date", prev);
        window.localStorage.setItem("next_date", next);

        this.props.dispatch(setCustomTimeframe({ next, prev }));
        this.props.dispatch(setCurrentPage(1));
        this.props.dispatch(ajaxFeedbackFilterV2(true, true))
    }

    getStatusDropdownItems() {
        let dropdownItems = [
            { text: window.feedbackStatus.Open.label, id: window.feedbackStatus.Open.value, link: '?status=' + window.feedbackStatus.Open.value },
            { text: window.feedbackStatus.Pending.label, id: window.feedbackStatus.Pending.value, link: '?status=' + window.feedbackStatus.Pending.value },
            { text: window.feedbackStatus.Resolved.label, id: window.feedbackStatus.Resolved.value, link: '?status=' + window.feedbackStatus.Resolved.value },
            { text: __('All'), id: 'All', link: '?status=All' }
        ];

        if (this.props.state.businessHasAutoPilot) {
            dropdownItems.push({ text: window.feedbackStatus.RatingsOnly.label, id: window.feedbackStatus.RatingsOnly.value });
        }

        return dropdownItems;
    }
    render() {
        return (
            <Bar>
                <div className={'search-bar-wrapper d-flex w-100'}>
                    <div className={'d-flex search-bar-wrapper w-100'}>
                        <div className="d-flex search-bar-wrapper-reverse">
                            <div className="align-items-center mr-1" style={{ display: this.props.state.timeframe === "custom" ? "flex" : "none" }}>
                                <div>
                                    <input
                                        className="form-control custom-date mr-2"
                                        style={{ padding: "0px" }}
                                        value={this.props.state.timeframe_prev}
                                        onChange={() => { this.doChangeTimeFrame() }}
                                        type="date"
                                        min='1899-01-01'
                                        max={this.props.state.max_Date}
                                        id="start_date"
                                        required
                                    />
                                </div>
                                <div className="mx-1">{__('To')}</div>
                                <div>
                                    <input
                                        style={{ padding: "0px" }}
                                        className="form-control custom-date mr-2"
                                        value={this.props.state.timeframe_next}
                                        onChange={() => { this.doChangeTimeFrame() }}
                                        type="date"
                                        min='1899-01-01'
                                        max={this.props.state.max_Date}
                                        id="end_date"
                                        required
                                    />
                                </div>
                            </div>
                            <FormDropdown
                                title={convertTimeframeTitle(this.props.state.timeframe)}
                                items={
                                    [
                                        { text: __('Today'), id: "today" },
                                        { text: __('Yesterday'), id: "yesterday" },
                                        { text: __('Week to Date'), id: "weekToDate" },
                                        { text: __('Month to Date'), id: "monthToDate" },
                                        { text: __('Last 30 Days'), id: "last30" },
                                        { text: __('Lifetime'), id: "lifetime" },
                                        { text: __('Custom'), id: "custom" }
                                    ]
                                }
                                classes={"mr-2 roboto"}
                                buttonClasses={"roboto"}
                                itemOnClickFunction={this.dispatchTimeframe.bind(this)}
                            />
                        </div>
                        <div className="d-flex w-100">
                            <form className="w-100 position-relative d-flex align-items-center " onSubmit={(e) => {
                                e.preventDefault();
                                this.dispatchSearch();
                            }}>
                                <FormInput
                                    placeholder={__('Search Feedbacks...')}
                                    classes={"w-100 roboto feedback-search"}
                                    onChange={
                                        () => {
                                            if ($("input.feedback-search").val() !== "") {
                                                this.setState({ ...this.state, displayClear: true })
                                            } else {
                                                this.setState({ ...this.state, displayClear: false })
                                            }
                                        }
                                    }
                                    defaultValue={this.props.state.query}
                                />
                                {this.state.displayClear && <span className='position-absolute cursor-pointer' onClick={() => {
                                    $("input.feedback-search").val("");
                                    this.dispatchSearch();
                                    this.setState({ ...this.state, displayClear: false })
                                }} style={{ right: '35px' }}>x</span>}
                            </form>
                            <span onClick={this.dispatchSearch.bind(this)}
                                className="btn btn-primary searchbar-button position-relative">{__('Search')}</span>
                        </div>
                    </div>

                    <div className={'d-flex searchbar-dropdowns-wrapper'}>
                        <FormDropdown
                            title={window.feedbackStatus[this.state.status] ? window.feedbackStatus[this.state.status].label : 'All'}
                            items={this.getStatusDropdownItems()}
                            classes={"mr-2 roboto"}
                            buttonClasses={"roboto"}
                        />
                    </div>
                    {this.props.state.title !== "More" && <div className="d-none d-xl-flex btn btn-primary text-nowrap" onClick={this.handleExportClick.bind(this)}>
                        {__('Export to Spreadsheet')}
                    </div>}
                </div>
            </Bar>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(SearchBar);
